import React from 'react';
import PropTypes from 'prop-types';

import { LRS_OBJECT_TYPES } from '@techchange/components';

import { RESOURCE_TYPES } from '../../constants';

import RuleEditorForCertificate from './content/certificate';
import RuleEditorForEmbed from './content/embed';
import RuleEditorForForm from './content/form';
import RuleEditorForImage from './content/image';
import RuleEditorForMiro from './content/miro';
import RuleEditorForQuiz from './content/quiz';
import RuleEditorForSlide from './content/slide';
import RuleEditorForVideo from './content/video';

import './RuleEditor.scss';

const propTypes = {

	/**
	 * The resource.
	 */
	resource: PropTypes.shape({

		/*
		 * The resource type.
		 */
		type: PropTypes.string,

		/**
		 * Child resources of the resource
		 */
		children: PropTypes.arrayOf(PropTypes.shape({

			/**
			 * Unique ID for the resource
			 */
			id: PropTypes.string,

			/**
			 * Title for the resource
			 */
			title: PropTypes.string,

		})),

	}).isRequired,

	/**
	 * The rule and associated tracker for the resource.
	 */
	rule: PropTypes.shape({

		/**
		 * Condition for the rule
		 */
		condition: PropTypes.shape({

			/**
			 * Unique ID for the condition
			 */
			id: PropTypes.string,

			/**
			 * Count of the condition
			 */
			count: PropTypes.number,

			/**
			 * Operator of the condition
			 */
			operator: PropTypes.string,

			/**
			 * Subconditions of the condition
			 */
			subconditions: PropTypes.arrayOf(PropTypes.shape({

				/**
				 * Unique identifier for the subcondition's object
				 */
				object_id: PropTypes.string,

			})),
		}),

	}),

	/**
	 * The parent resource.
	 */
	parent: PropTypes.shape({

		/*
		 * The parent resource type.
		 */
		type: PropTypes.string,

	}).isRequired,

	/**
	 * The current user's ID.
	 */
	userId: PropTypes.string.isRequired,

	/**
	 * The list of DEPRECATED gravity forms.
	 */
	gravityForms: PropTypes.arrayOf(PropTypes.shape({

		title: PropTypes.string.isRequired,

		tc_uuid: PropTypes.string.isRequired,

	})),

	/**
	 * Callback function to handle cancelling the rule editor.
	 */
	onCancel: PropTypes.func,

	/**
	 * Callback function to handle saving the rule.
	 */
	onSave: PropTypes.func.isRequired,

};

const RuleEditor = (props) => {

	const { resource: { type } } = props;

	switch (type) {

	case LRS_OBJECT_TYPES.CERTIFICATE:

		return <RuleEditorForCertificate {...props} />;

	case RESOURCE_TYPES.EMBED:

		return <RuleEditorForEmbed {...props} />;

	case RESOURCE_TYPES.IMAGE:

		return <RuleEditorForImage {...props} />;

	case RESOURCE_TYPES.MIRO:

		return <RuleEditorForMiro {...props} />;

	case RESOURCE_TYPES.FORM:

		return <RuleEditorForForm {...props} />;

	case RESOURCE_TYPES.POLL:

		return <RuleEditorForForm {...props} />;

	case RESOURCE_TYPES.QUIZ:

		return <RuleEditorForQuiz {...props} />;

	case RESOURCE_TYPES.SLIDE:

		return <RuleEditorForSlide {...props} />;

	case RESOURCE_TYPES.VIDEO:

		return <RuleEditorForVideo {...props} />;

	default:

		console.warn('The provided content type is not supported...');
		return null;

	}

};

RuleEditor.propTypes = propTypes;

export default RuleEditor;
